import React from "react";
import { Box, Typography, useTheme } from "@mui/material";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import EmailIcon from "@mui/icons-material/Email";
import { string } from "../../../constants/string";

export default function ContactInfo() {
  const theme = useTheme();

  const infoItems = [
    { label: string.welcome.whistleBlower },
    { label: string.welcome.hotline },
    { label: string.welcome.iSave },
    { label: string.welcome.payments },
  ];

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: {
          xs: "column",
          sm: "row",
        },
        justifyContent: "space-between",
        alignItems: "center",
        px: {
          xs: 2,
          sm: 6,
          md: 12,
          lg: 18,
        },
        py: 1,
        borderBottom: `1px solid ${theme.palette.divider}`,
        gap: {
          xs: 1.5,
          sm: 0,
        },
      }}
    >
      {/* Left: Phone + Email */}
      <Box
        sx={{
          display: "flex",
          flexDirection: {
            sm: "row",
          },
          alignItems: {
            xs: "flex-start",
            sm: "center",
          },
          gap: 3,
        }}
      >
        {/* Phone */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <LocalPhoneIcon sx={{ color: "text.primary", fontSize: 20 }} />
          <Typography
            variant="body2"
            sx={{ fontWeight: 600, cursor: "pointer" }}
          >
            {string.welcome.phoneNumber}
          </Typography>
        </Box>

        {/* Email */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <EmailIcon sx={{ color: "text.primary", fontSize: 20 }} />
          <Typography
            variant="body2"
            sx={{ fontWeight: 600, cursor: "pointer" }}
          >
            {string.welcome.email}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
